/*
 * Strato Lab 3D — dedicated pages content (Italian).
 */

/* ---------------- Servizi ---------------- */
export const SERVICES_INCLUDE = {
  microLabel: "COSA INCLUDE",
  title: "Un servizio, non solo una stampa.",
  description:
    "Ogni progetto include valutazione tecnica e accompagnamento, dal file alla consegna.",
  items: [
    {
      title: "Analisi tecnica umana",
      description:
        "Un tecnico verifica stampabilità, spessori e tolleranze prima di ogni preventivo.",
    },
    {
      title: "Orientamento e ottimizzazione",
      description:
        "Scegliamo orientamento, riempimento e supporti per il miglior risultato.",
    },
    {
      title: "Finitura base",
      description:
        "Rimozione dei supporti e pulizia delle superfici incluse di serie.",
    },
    {
      title: "Imballo protettivo",
      description:
        "Confezionamento pensato per proteggere il pezzo durante il trasporto.",
    },
  ],
};

/* ---------------- Materiali ---------------- */
export const MATERIAL_PROPERTIES = {
  microLabel: "PROPRIETÀ PLA",
  title: "Perché il PLA.",
  description:
    "Un materiale versatile e stabile, ideale per la maggior parte delle applicazioni su richiesta.",
  rows: [
    { label: "Rigidità", value: "Alta" },
    { label: "Finitura", value: "Satinata / opaca" },
    { label: "Dettaglio", value: "Elevato" },
    { label: "Layer", value: "0.08 – 0.28 mm" },
    { label: "Usi consigliati", value: "Prototipi, componenti visivi, piccole serie" },
    { label: "Colori", value: "5 standard + colori su richiesta" },
    { label: "Altri materiali", value: "Su richiesta, in base al progetto" },
  ],
};

/* ---------------- Metodo Strato ---------------- */
export const METHOD = {
  microLabel: "METODO STRATO",
  title: "Precisione, controllo, ripetibilità.",
  description:
    "Il nostro metodo unisce valutazione tecnica umana e produzione controllata, per un risultato coerente nel tempo.",
  principles: [
    {
      title: "Valutazione tecnica umana",
      description:
        "Nessun automatismo cieco: ogni file è esaminato da una persona prima della produzione.",
    },
    {
      title: "Produzione controllata",
      description:
        "Parametri calibrati e profili documentati su sistemi Bambu Lab con filamenti originali Bambu Lab.",
    },
    {
      title: "Tracciabilità",
      description:
        "Materiale e parametri principali vengono documentati nella gestione tecnica della richiesta.",
    },
    {
      title: "Riservatezza",
      description:
        "I tuoi file sono trattati come riservati e usati solo per la tua richiesta.",
    },
  ],
};

/* ---------------- Chi siamo ---------------- */
export const ABOUT = {
  microLabel: "CHI SIAMO",
  title: "Un laboratorio, non una fabbrica.",
  description:
    "Strato Lab 3D è un laboratorio italiano di stampa 3D FDM su richiesta. Trasformiamo file e idee in pezzi reali, con un approccio tecnico e umano.",
  paragraphs: [
    "Nasciamo dall'idea che la produzione su richiesta debba essere semplice per il cliente e rigorosa nel processo. Per questo uniamo valutazione tecnica umana e produzione controllata.",
    "Non siamo un marketplace né un catalogo: ci occupiamo del tuo pezzo, uno alla volta o in piccole serie, curando ogni fase dalla preparazione del file alla consegna.",
  ],
  values: [
    { title: "Chiarezza", description: "Tempi, materiali e costi comunicati in modo semplice." },
    { title: "Controllo", description: "Parametri coerenti e ripetibili, stampa dopo stampa." },
    { title: "Cura", description: "Attenzione al dettaglio, dalla finitura all'imballo." },
  ],
  stats: [
    { label: "TECNOLOGIA", value: "FDM" },
    { label: "MATERIALE", value: "PLA" },
    { label: "MODELLO", value: "Su richiesta" },
    { label: "OPERATIVITÀ", value: "Italia" },
  ],
};

/* ---------------- Contatti ---------------- */
export const CONTACT = {
  microLabel: "CONTATTI",
  title: "Parliamo del tuo progetto.",
  description:
    "Scrivici per una valutazione tecnica o per qualsiasi domanda. Per una richiesta completa, usa il configuratore del preventivo.",
  info: [
    { label: "RISPOSTA", value: "Entro 1–2 giorni lavorativi" },
    { label: "CANALI", value: "Richieste gestite in digitale" },
  ],
  reasons: [
    "Richiesta di informazioni",
    "Valutazione tecnica",
    "Collaborazione",
    "Altro",
  ],
};

/* ---------------- Stato richiesta ---------------- */
export const STATUS_STATES = [
  "Richiesta ricevuta",
  "Analisi tecnica",
  "Preventivo pronto",
  "In attesa di pagamento",
  "Pagamento ricevuto",
  "In produzione",
  "Spedito",
  "Consegnato",
];

/* ---------------- Service category pages ---------------- */
export const SERVICE_CATEGORIES = {
  "prototipi-funzionali": {
    micro: "SERVIZIO",
    glyph: "prototype",
    title: "Prototipi funzionali",
    description:
      "Trasformiamo un'idea o un modello in un prototipo reale da toccare, testare e iterare rapidamente.",
    useCases: [
      "Validazione di forma ed ergonomia",
      "Verifica di incastri e accoppiamenti",
      "Test funzionali preliminari",
      "Presentazione di un concept",
    ],
    evaluate: [
      "File 3D (STL, STEP, 3MF) oppure schizzo o riferimento",
      "Dimensioni indicative e tolleranze critiche",
      "Uso previsto del prototipo",
      "Quantità e tempi desiderati",
    ],
  },
  "componenti-tecnici": {
    micro: "SERVIZIO",
    glyph: "techComponent",
    title: "Componenti tecnici",
    description:
      "Parti funzionali con geometrie precise e tolleranze verificate, pensate per essere usate davvero.",
    useCases: [
      "Componenti meccanici non strutturali",
      "Alloggiamenti, guide e supporti interni",
      "Parti di ricambio tecniche",
      "Piccole serie ripetibili",
    ],
    evaluate: [
      "File 3D con quote critiche evidenziate",
      "Tolleranze e accoppiamenti richiesti",
      "Condizioni d'uso (carico, temperatura indicativa)",
      "Quantità e finitura desiderata",
    ],
  },
  "ricambi-adattamenti": {
    micro: "SERVIZIO",
    glyph: "sparePart",
    title: "Ricambi e adattamenti",
    description:
      "Ricostruiamo un pezzo non più disponibile o lo adattiamo a nuove esigenze, partendo da ciò che hai.",
    useCases: [
      "Ricambi fuori produzione",
      "Adattatori e raccordi su misura",
      "Modifiche a componenti esistenti",
      "Ripristino di parti danneggiate",
    ],
    evaluate: [
      "Pezzo originale, foto o misure dettagliate",
      "Punti di fissaggio e vincoli",
      "Materiale e colore desiderati",
      "Quantità necessaria",
    ],
  },
  "supporti-dime": {
    micro: "SERVIZIO",
    glyph: "bracket",
    title: "Supporti e dime",
    description:
      "Staffe, dime e supporti dedicati per fissare, posizionare e lavorare con precisione.",
    useCases: [
      "Staffe di supporto e montaggio",
      "Dime di foratura e assemblaggio",
      "Supporti per attrezzature",
      "Organizer e portaoggetti tecnici",
    ],
    evaluate: [
      "Oggetto o superficie da supportare",
      "Ingombri e punti di fissaggio",
      "Ambiente d'uso",
      "Quantità e ripetibilità",
    ],
  },
  "contenitori-gusci": {
    micro: "SERVIZIO",
    glyph: "enclosure",
    title: "Contenitori e gusci",
    description:
      "Custodie, gusci e alloggiamenti su misura per proteggere e contenere componenti ed elettronica.",
    useCases: [
      "Custodie per elettronica",
      "Gusci e cover tecniche",
      "Alloggiamenti per sensori",
      "Contenitori dedicati",
    ],
    evaluate: [
      "Dimensioni interne e ingombri",
      "Aperture, fori e passaggi cavi",
      "Tolleranze di accoppiamento",
      "Materiale, colore e quantità",
    ],
  },
  "piccole-serie": {
    micro: "SERVIZIO",
    glyph: "series",
    title: "Piccole serie",
    description:
      "Lotti ripetibili con qualità costante, pezzo dopo pezzo, mantenendo parametri e finitura coerenti.",
    useCases: [
      "Serie limitate",
      "Ricambi ripetibili",
      "Componenti per piccoli prodotti",
      "Set coordinati",
    ],
    evaluate: [
      "File 3D validato",
      "Quantità del lotto",
      "Tolleranze e finitura richieste",
      "Tempi di consegna",
    ],
  },
};

/* ---------------- Legal & informative pages ----------------
 * Verbatim content from STRATO_LEGAL_EMERGENT_PACKAGE.md.
 * No invented data: no P.IVA / REA / CF / address / phone / IBAN.
 * Titolare: Paola Sacchetto — Contatto: stratolab3d.mc@gmail.com
 */
export const LEGAL_EMAIL = "stratolab3d.mc@gmail.com";
export const LEGAL_UPDATED = "Ultimo aggiornamento: agosto 2026";

export const LEGAL_CONTENT = {
  "privacy-policy": {
    micro: "PRIVACY",
    title: "Privacy Policy",
    intro:
      "Questa informativa descrive in modo sintetico come Strato Lab 3D tratta i dati ricevuti tramite sito, modulo preventivo e comunicazioni operative.",
    sections: [
      {
        heading: "Chi gestisce i dati",
        paragraphs: [
          "Il titolare del trattamento dei dati personali raccolti tramite il sito Strato Lab 3D è Paola Sacchetto.",
          "Per richieste relative al trattamento dei dati personali è possibile scrivere a: stratolab3d.mc@gmail.com",
          "Strato Lab 3D non dispone di una sede aperta al pubblico per accesso clienti. Le richieste e le comunicazioni vengono gestite tramite canali digitali.",
          "Non è stato designato un Responsabile della Protezione dei Dati (RPD/DPO).",
        ],
      },
      {
        heading: "Informazioni che possiamo ricevere",
        paragraphs: [
          "Possiamo raccogliere dati di contatto, informazioni inserite nel modulo preventivo, file caricati per la valutazione tecnica e dati tecnici di navigazione necessari al funzionamento del sito.",
        ],
      },
      {
        heading: "Perché usiamo questi dati",
        paragraphs: [
          "Usiamo le informazioni per rispondere alle richieste, analizzare i file, preparare un preventivo tecnico, gestire comunicazioni operative e migliorare la sicurezza del servizio.",
        ],
      },
      {
        heading: "Uso dei file caricati",
        paragraphs: [
          "I file vengono utilizzati per valutare stampabilità, materiale, dimensioni e vincoli del progetto. Non vengono trattati come contenuti pubblici o materiale promozionale senza autorizzazione.",
        ],
      },
      {
        heading: "Conservazione e aggiornamenti",
        paragraphs: [
          "I dati vengono conservati per il tempo utile a gestire la richiesta e gli obblighi collegati. L'informativa può essere aggiornata per riflettere eventuali variazioni operative del servizio.",
        ],
      },
    ],
  },

  "cookie-policy": {
    micro: "COOKIE",
    title: "Cookie Policy",
    intro:
      "Questa pagina spiega in modo sintetico l'uso dei cookie e delle tecnologie tecniche collegate al funzionamento del sito Strato Lab 3D.",
    sections: [
      {
        heading: "Cookie necessari",
        paragraphs: [
          "Il sito può usare cookie tecnici necessari al funzionamento della navigazione, alla sicurezza, alla gestione della sessione e alle funzioni base della piattaforma Shopify.",
        ],
      },
      {
        heading: "Impostazioni del browser",
        paragraphs: [
          "Puoi gestire o limitare i cookie dalle impostazioni del browser. Alcune funzioni tecniche del sito potrebbero non funzionare correttamente se i cookie necessari vengono disabilitati.",
        ],
      },
      {
        heading: "Cookie analitici o marketing",
        paragraphs: [
          "Eventuali cookie analitici, marketing o tracciamenti aggiuntivi vengono indicati quando effettivamente attivi e gestiti secondo le preferenze di consenso previste.",
        ],
      },
      {
        heading: "Aggiornamento della policy",
        paragraphs: [
          "La cookie policy può essere aggiornata quando cambiano gli strumenti tecnici, di consenso o di misurazione utilizzati dal sito.",
        ],
      },
    ],
  },

  "termini-condizioni": {
    micro: "TERMINI E CONDIZIONI",
    title: "Termini e condizioni del servizio",
    intro:
      "I presenti termini regolano l'utilizzo del sito Strato Lab 3D e il servizio di richiesta preventivo per stampa 3D su specifica del cliente.",
    sections: [
      {
        paragraphs: [
          "Strato Lab 3D è il nome commerciale del servizio di stampa 3D su richiesta. Il servizio è gestito da Paola Sacchetto, referente amministrativo, legale e di pagamento.",
        ],
      },
      {
        heading: "1. Natura del servizio",
        paragraphs: [
          "Strato Lab 3D offre un servizio di stampa 3D su richiesta. Il sito consente agli utenti di inviare una richiesta di preventivo caricando un file 3D o descrivendo il pezzo da realizzare.",
          "L'invio del modulo non costituisce un ordine confermato, non comporta obbligo di acquisto e non equivale ad accettazione automatica da parte di Strato Lab 3D.",
        ],
      },
      {
        heading: "2. Valutazione tecnica e preventivo",
        paragraphs: [
          "A seguito della richiesta, Strato Lab 3D valuta il file, l'utilizzo previsto, il materiale, la quantità, i tempi e gli eventuali vincoli tecnici.",
          "Il cliente riceve una valutazione tecnica e, se il progetto è fattibile, un preventivo personalizzato. La produzione ha inizio esclusivamente dopo conferma esplicita del preventivo da parte del cliente e, ove previsto, dopo il pagamento concordato tramite il percorso indicato.",
        ],
      },
      {
        heading: "3. Prezzi, pagamenti e checkout",
        paragraphs: [
          "Prezzo, valuta, eventuali costi di spedizione e condizioni operative vengono comunicati nel preventivo.",
          "Quando viene inviato un link di pagamento, il pagamento viene gestito tramite checkout Shopify. L'ordine si considera confermato solo dopo il completamento del pagamento, salvo diverso accordo scritto.",
        ],
      },
      {
        heading: "4. File, contenuti e responsabilità del cliente",
        paragraphs: [
          "Il cliente è responsabile dei file, dei riferimenti, delle misure, delle specifiche tecniche e dei diritti necessari per richiedere la produzione.",
          "Non vengono accettate richieste relative a oggetti illegali, pericolosi, lesivi di diritti di terzi o non idonei alla produzione. Strato Lab 3D può rifiutare una richiesta o chiedere chiarimenti prima di procedere.",
        ],
      },
      {
        heading: "5. Produzione su specifica",
        paragraphs: [
          "I pezzi realizzati da Strato Lab 3D sono prodotti su file, misure o indicazioni del cliente. Finitura, colore, orientamento dei layer, tolleranze e resa finale possono variare in base a geometria, materiale e tecnologia di stampa 3D utilizzata.",
          "Eventuali requisiti critici devono essere comunicati prima dell'approvazione del preventivo.",
        ],
      },
      {
        heading: "6. Spedizione e consegna",
        paragraphs: [
          "Tempi, costi e modalità di spedizione vengono definiti caso per caso in base al pezzo, al materiale, alla quantità, alla destinazione e al livello di protezione necessario.",
          "Strato Lab 3D non garantisce tempi di consegna fissi indipendenti dalla complessità del progetto, dalla produzione e dal corriere.",
        ],
      },
      {
        heading: "7. Resi e rimborsi",
        paragraphs: [
          "Le condizioni relative a resi, rimborsi, difetti o non conformità sono indicate nell'informativa su resi e rimborsi.",
          "Poiché molti pezzi sono realizzati su specifica del cliente, eventuali richieste vengono valutate con riferimento al preventivo confermato, alle caratteristiche del pezzo e alla documentazione disponibile.",
        ],
      },
      {
        heading: "8. Annullamenti",
        paragraphs: [
          "Le richieste di annullamento dopo la conferma del preventivo o dopo il pagamento vengono valutate caso per caso. Se la produzione è già iniziata o il pezzo è stato realizzato su specifica del cliente, l'annullamento potrebbe non essere accettabile o potrebbe comportare costi già sostenuti.",
        ],
      },
      {
        heading: "9. Contatti",
        paragraphs: [
          "Per informazioni sul servizio o sulle condizioni applicabili è possibile scrivere a:",
          "stratolab3d.mc@gmail.com",
        ],
      },
    ],
  },

  "resi-rimborsi": {
    micro: "RESI E RIMBORSI",
    title: "Informativa su resi e rimborsi",
    intro:
      "Strato Lab 3D realizza pezzi stampati in 3D su richiesta, partendo da file, misure, indicazioni tecniche o descrizioni fornite dal cliente.",
    sections: [
      {
        paragraphs: [
          "Strato Lab 3D è il nome commerciale del servizio di stampa 3D su richiesta. Il servizio è gestito da Paola Sacchetto, referente amministrativo, legale e di pagamento.",
        ],
      },
      {
        heading: "1. Pezzi personalizzati",
        paragraphs: [
          "Molti componenti vengono prodotti su specifica del cliente. Per questa ragione, eventuali resi vengono valutati rispetto al preventivo approvato, alla natura personalizzata del pezzo e alle caratteristiche tecniche concordate.",
          "Per i pezzi realizzati su misura o chiaramente personalizzati non è previsto un reso automatico per semplice ripensamento. Le richieste di reso automatico e i resi self-service non sono attivi.",
          "Resta sempre possibile segnalare via email difetti, errori di produzione, non conformità rispetto alla proposta tecnica confermata o problemi legati alla consegna. Ogni segnalazione viene gestita manualmente e valutata caso per caso.",
        ],
      },
      {
        heading: "2. Problemi, difetti o non conformità",
        paragraphs: [
          "Se il pezzo ricevuto presenta un problema, un difetto di produzione o una non conformità rispetto alla proposta tecnica confermata, il cliente deve contattare Strato Lab 3D indicando:",
        ],
        list: [
          "codice richiesta o riferimento ordine;",
          "descrizione del problema;",
          "foto chiare del pezzo;",
          "foto dell'imballo, se il problema riguarda la consegna.",
        ],
        paragraphsAfter: [
          "Le segnalazioni devono essere inviate a:",
          "stratolab3d.mc@gmail.com",
        ],
      },
      {
        heading: "3. Valutazione caso per caso",
        paragraphs: [
          "Ogni richiesta viene valutata singolarmente. Se il problema dipende dalla produzione o da una non conformità confermata, Strato Lab 3D può proporre una soluzione proporzionata al caso, ad esempio rilavorazione, sostituzione, rimborso parziale o rimborso totale.",
        ],
      },
      {
        heading: "4. Esclusioni",
        paragraphs: [
          "Non sono normalmente oggetto di rimborso o sostituzione i problemi derivanti da:",
        ],
        list: [
          "file forniti in modo incompleto, errato o non idoneo alla stampa 3D;",
          "misure o specifiche comunicate in modo non corretto;",
          "requisiti tecnici non dichiarati prima dell'approvazione del preventivo;",
          "uso improprio del pezzo dopo la consegna;",
          "danni successivi alla consegna non imputabili alla produzione.",
        ],
      },
      {
        heading: "5. Danni da trasporto",
        paragraphs: [
          "In caso di danni visibili all'imballo o al pezzo, il cliente deve conservare confezione e documentazione fotografica. La valutazione richiede immagini e dettagli della consegna.",
        ],
      },
    ],
  },

  spedizioni: {
    micro: "SPEDIZIONI",
    title: "Informativa sulle spedizioni",
    intro:
      "La spedizione di un pezzo stampato in 3D dipende da geometria, materiale, quantità, destinazione e livello di protezione necessario.",
    sections: [
      {
        heading: "1. Spedizione definita nel preventivo",
        paragraphs: [
          "Tempi, costi e modalità di spedizione vengono comunicati nel preventivo o nel passaggio operativo successivo, prima della conferma definitiva della produzione.",
          "Strato Lab 3D non lavora come catalogo ecommerce standard con tempi e costi identici per ogni prodotto. Ogni richiesta viene valutata sul progetto.",
        ],
      },
      {
        heading: "2. Produzione prima della spedizione",
        paragraphs: [
          "La spedizione avviene dopo stampa, controllo e preparazione del pezzo. I tempi possono variare in base a complessità, materiale, quantità, corriere e destinazione.",
        ],
      },
      {
        heading: "3. Imballaggio",
        paragraphs: [
          "Ogni parte viene preparata considerando geometria, fragilità, finitura e rischio di deformazione. Componenti sottili, tecnici o funzionali possono richiedere imballaggio più attento.",
        ],
      },
      {
        heading: "4. Tracking",
        paragraphs: [
          "Quando disponibile, il codice di tracciamento viene comunicato dopo l'affidamento al corriere.",
        ],
      },
      {
        heading: "5. Ritiro o spedizione",
        paragraphs: [
          "Quando possibile, il ritiro può essere concordato. In alternativa la consegna viene organizzata in base alle caratteristiche del pezzo e all'imballaggio necessario.",
        ],
      },
      {
        heading: "6. Contatti",
        paragraphs: [
          "Per informazioni su una spedizione o su una richiesta già inviata:",
          "stratolab3d.mc@gmail.com",
        ],
      },
    ],
  },

  "informativa-legale": {
    micro: "INFORMATIVA LEGALE",
    title: "Informativa legale",
    sections: [
      {
        paragraphs: [
          "Strato Lab 3D è il nome commerciale del servizio di stampa 3D su richiesta. Il servizio è gestito da Paola Sacchetto, referente amministrativo, legale e di pagamento.",
        ],
      },
      {
        heading: "Servizio offerto",
        paragraphs: [
          "Stampa 3D su richiesta per prototipi, componenti, piccole serie e oggetti personalizzati, previa valutazione tecnica e preventivo.",
        ],
      },
      {
        heading: "Contatto",
        paragraphs: ["stratolab3d.mc@gmail.com"],
      },
      {
        heading: "Modalità operativa",
        paragraphs: [
          "Il cliente invia una richiesta tramite sito, allegando un file 3D o descrivendo il pezzo. Strato Lab 3D valuta fattibilità, materiali, tempi e costi prima di confermare eventuale produzione.",
          "La produzione non parte automaticamente dall'invio del modulo. La produzione avviene solo dopo conferma del preventivo e, ove previsto, dopo pagamento.",
        ],
      },
    ],
  },
};

/* Route slug aliases → legal content keys (keeps old links working) */
export const LEGAL_ALIASES = {
  privacy: "privacy-policy",
  cookie: "cookie-policy",
  termini: "termini-condizioni",
  resi: "resi-rimborsi",
};
